import { UrlConstants } from "../url.constants";
export class ApiAssessmentConstants {
    static URL = UrlConstants.API_V2 + "Assessment";
}
